import {
  changePin,
  confirmPinReset,
  createPin,
  PinLockDelayResponse,
  PinResetRequestResponse,
  PinStatusResponse,
  postActivity,
  requestPinReset,
  unlockWithPin,
  updatePinLockDelay,
} from "../webclients/pin.client";

export const pinApi = {
  create: async (pin: string): Promise<PinStatusResponse> =>
    (await createPin(pin)).data,

  unlock: async (pin: string): Promise<PinStatusResponse> =>
    (await unlockWithPin(pin)).data,

  change: async (currentPin: string, newPin: string): Promise<PinStatusResponse> =>
    (await changePin(currentPin, newPin)).data,

  requestReset: async (): Promise<PinResetRequestResponse> =>
    (await requestPinReset()).data,

  updateLockDelay: async (lockMinutes: number): Promise<PinLockDelayResponse> =>
    (await updatePinLockDelay(lockMinutes)).data,

  activity: async (): Promise<void> => {
    await postActivity();
  },

  confirmReset: async (otp: string, newPin: string): Promise<PinStatusResponse> =>
    (await confirmPinReset(otp, newPin)).data,
};
